import React from 'react';
import 'CSS/demand-supply/demand-supply.scss';
import 'CSS/dashboard-statistic.scss';
import 'CSS/dashboard-tickets.scss';
import 'CSS/dashboard-slips.scss';
import Grid from '@material-ui/core/Grid';
import styled from 'styled-components';
// import dompurify from 'dompurify';

const NoteNumb = styled.span`
  color: black;
  font-weight: bold;
`;
const Note = styled.p`
  display: block !important;
`;

const separateNotes = note => {
  const checkIfCanDecode = item => {
    try {
      const decode = decodeURI(item);
      return decode;
    } catch (err) {
      return item;
    }
  };
  if (note) {
    // const sanitizer = dompurify.sanitize;
    // let noteSanitizer = sanitizer(note);
    let noteSanitizer = note;
    let split = noteSanitizer.split('_$_');
    return split.map((el, index) => (
      <Note key={index}>
        <NoteNumb>{index + 1 + '. '}</NoteNumb> {checkIfCanDecode(el)}
      </Note>
    ));
  }
};
export const Notes = props => {
  return (
    <Grid
      item
      // lg={4}
      // md={6}
      xs={6}
    >
      <Grid container className="u-pad-bot-10 ">
        <Grid
          item
          // lg={4}
          // md={6}
          xs={6}
          className=""
        >
          <h2 className="t-primary-16 t-weight-b u-mrg-bot-10 u-mrg-top-0">
            Notes
          </h2>
        </Grid>
        <Grid container className="t-primary-14 c-gray-light">
          <div>{separateNotes(props.note)}</div>
        </Grid>
      </Grid>
    </Grid>
  );
};
